import { render } from "./MerchPartners.vue?vue&type=template&id=7728b8d9&scoped=true"
const script = {}

import "./MerchPartners.vue?vue&type=style&index=0&id=7728b8d9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7728b8d9"]])

export default __exports__